import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./index.css";

export default class RightIconMenu extends Component {
	constructor(props) {
		super(props);

		this.state = {
			rightIconMenu: props.data,
		};
	}

	render() {

		return (
			<div className="RightIconMenu">
				<ul className="">
					{this.state.rightIconMenu.map((object,i)=>{
						if (
							object.url.indexOf("http") > -1
						) {
							return (
								<span>
									<div className="extendetnav-item-div" style={{backgroundImage: "url("+object.img+")", backgroundPosition: "center", backgroundSize: "cover"}}></div>
									<a className="RightIconMenu__link" target="_blank"
									href={object.url}>{object.name}</a>
								</span>
							);
						} else {
							return (
								<span>
									<div className="extendetnav-item-div" style={{backgroundImage: "url("+object.img+")", backgroundPosition: "center", backgroundSize: "cover"}}></div>
									<Link className="RightIconMenu__link" to={"/" + object.url}>{object.name}</Link>
								</span>
							);
						}
					})}
				</ul>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Components/Elements/RightIconMenu/index.js